import React from 'react';

import { ReactComponent } from '../../assets/svg/dashboard.svg';


export default () => <ReactComponent />;
